import { useMutation, useQueryClient } from "@tanstack/react-query"
import DeleteModal from "components/Common/DeleteModal"
import useDisclosure from "hooks/useDisclosure"
import React from "react"
import { Button } from "reactstrap"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import EditTemplateModal from "./EditTemplateModal"
import { deleteFolderTemplate } from "api/folderTemplateApi"

function TemplateItem({ templateData }) {
  const { id, name, keywords } = templateData
  const editModal = useDisclosure()
  const deleteModal = useDisclosure()
  const queryClient = useQueryClient()

  // delete ip address mutation
  const { mutate, isPending } = useMutation({
    mutationFn: deleteFolderTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries("folder_templates")
      deleteModal.close()
    },
    onError: error => toast.error(error),
  })
  
  // todo: render keywords of item
  return (
    <React.Fragment>
      {editModal.isOpen ? (
        <EditTemplateModal
          isOpen={editModal.isOpen}
          toggle={editModal.close}
          templateData={templateData}
        />
      ) : null}
      {deleteModal.isOpen ? (
        <DeleteModal
          show={deleteModal.isOpen}
          onDeleteClick={() => mutate(id)}
          onCloseClick={deleteModal.close}
          isLoading={isPending}
        />
      ) : null}
      <div className="bg-light  px-3 py-2 rounded space-between">
        <h6 className="h5 mb-0">{name}</h6>
        <div className="hstack gap-1">
          <Button color="soft-primary" onClick={editModal.open}>
            <i className="bx bx-pencil"></i>
          </Button>
          <Button color="soft-danger" onClick={deleteModal.open}>
            <i className="bx bx-trash"></i>
          </Button>
        </div>
      </div>
    </React.Fragment>
  )
}

TemplateItem.propTypes = {
  templateData: PropTypes.object,
}

export default TemplateItem
